import { CAMPAIGN_ID, CAMPAIGN_TITLE, tabOfSettings } from './data';
import queryString from 'query-string';

export const AppRoutes = {
  HomePage: '/',
  Login: '/login',
  ForgotPassword: '/forgot-password',
  ResetPassword: '/reset-password',

  Contact: '/contact',
  ContactGroup: '/contact/groups',
  ContactDetail: '/contact/groups/:groupId/:tab',
  ContactDetailWithId: (id, tab) => `/contact/groups/${id}/${tab || 'detail'}`,

  ContactV2: '/contact-v2',
  ContactGroupV2: '/contact-v2/groups',
  ContactDetailV2: '/contact-v2/groups/:groupId/:tab',
  ContactDetailV2WithId: (id, tab) => `/contact-v2/groups/${id}/${tab || 'detail'}`,
  ContactFindAPhoneV2: '/contact-v2/find-a-phone',

  ContactFindAPhone: '/contact/find-a-phone',

  Send: '/send',
  CampaignCompose: '/send/campaign-compose',
  Inbox: '/inbox',
  Users: '/users',
  Statistic: '/statistic',
  Settings: '/settings',
  InvoiceDetail: '/settings/invoice/:id',
  InvoiceDetailWithId: (id) => `/settings/invoice/${id}`,
  RouteDetailWithName: (name) => `
  ${AppRoutes.Settings}?${queryString.stringify({
    tab: tabOfSettings.routesInfo,
    route: name,
  })}`,

  Offers: '/send/offers',
  OffersDetail: '/send/offers/:id',
  OffersDetailWithId: (id) => `/send/offers/${id}`,
  OffersCreate: '/send/offers/create',

  CreativeCompose: '/send/creative-compose',
  CreativeComposeDetail: '/send/creative-compose/:id',
  CreativeComposeDetailWithId: (id) => `/send/creative-compose/${id}`,
  CreativeComposeCreate: '/send/creative-compose/create',

  //* Optout Link
  OptoutLink: '/send/optout-link',
  OptoutLinkDetail: '/send/optout-link/:id',
  OptoutLinkDetailWithId: (id) => `/send/optout-link/${id}`,
  OptoutLinkCreate: '/send/optout-link/create',

  Dids: '/dids',
  DidsDetail: '/dids/:id',
  DidsDetailWithId: (id) => `/dids/${id}`,

  Responders: '/responders',
  RespondersTemplate: '/responders/templates',
  RespondersDetail: '/responders/:id',
  RespondersDetailWithId: (id) => `/responders/${id}`,
  RespondersTemplateDetailWithId: (id) => `/responders/${id}?isResponderTemplate=true`,

  RespondersV2: '/responders-v2',
  RespondersV2Template: '/responders-v2/templates',
  RespondersV2Detail: '/responders-v2/:id',
  RespondersV2DetailWithId: (id) => `/responders-v2/${id}`,
  RespondersV2TemplateWithId: (id) => `/responders-v2/${id}?isResponderTemplate=true`,

  Domain: '/domain',
  DomainGroups: '/domain/groups',
  DomainDetail: '/domain/groups/:id',
  DomainDetailWithId: (id) => `/domain/groups/${id}`,

  DomainInActive: '/domain/inactive',

  NotificationSetting: '/notification-setting',
  Feedback: '/feedback',

  ManagementGuide: '/management-guide',
  ManagementGuideEdit: '/management-guide/edit',
  ManagementGuideEditRole: '/management-guide/edit/:role',
  ManagementGuideEditWithRole: (role) => `/management-guide/edit/${role}`,
  Guide: '/guide',

  Tickets: '/tickets',
  TicketsDetail: '/tickets/:id',
  TicketsDetailWithId: (id) => `/tickets/${id}`,
  TicketCreate: '/tickets/create',

  Analytics: '/analytics',

  MonitoringV2: '/monitoring-v2',
  Monitoring: '/monitoring',
  MonitoringWithIdAndTitleCampaign: (id, title) =>
    `/monitoring-v2?${CAMPAIGN_TITLE}=${title}&${CAMPAIGN_ID}=${id}`,

  Page429: '/429',
  Page404: '/404',

  TenDLC: '/10-dlc',
  TenDLCCreateNewBrandAndUseCase: '/10-dlc/create',
  TenDLCEditDetail: '/10-dlc/:id/edit',
  TenDLCEditDetailWithId: (id) => `/10-dlc/${id}/edit`,

  TenDLCDetail: '/10-dlc/:id',
  TenDLCDetailWithId: (id) => `/10-dlc/${id}`,

  TenDLCUseCase: '/10-dlc/:idBrand/use-case/:idUseCase',
  TenDLCCreateUseCase: '/10-dlc/:idBrand/use-case/new',
  TenDLCCreateUseCaseWithIdBrand: (idBrand) => `/10-dlc/${idBrand}/use-case/new`,
  TenDLCUseCaseWithId: (idBrand, idUseCase) => `/10-dlc/${idBrand}/use-case/${idUseCase}`,

  TenDLCUseCaseEdit: '/10-dlc/:idBrand/use-case/:idUseCase/edit',
  TenDLCUseCaseEditWithId: (idBrand, idUseCase) => `/10-dlc/${idBrand}/use-case/${idUseCase}/edit`,

  Process: '/process',

  PerformanceTracker: '/performance-tracker',
  PerformanceTrackerDID: '/performance-tracker/did',
  PerformanceTrackerDomain: '/performance-tracker/domain',
  PerformanceTrackerError: '/performance-tracker/error',

  Media: '/media',
  MediaStorage: '/media/storage',
  AudioBuilder: '/media/audio-builder',

  TFN: '/tfn',
  TFNCreate: '/tfn/create',
  TFNDetail: '/tfn/:id',
  TFNDetailWithId: (id) => `/tfn/${id}`,

  TFNEdit: '/tfn/:id/edit',
  TFNEditWithId: (id) => `/tfn/${id}/edit`,

  ReferralLandingPage: '/referral/:programId/:referralCode',

  Referral: '/referral',
  ReferralProgram: '/referral/program',
  ReferralStatistic: '/referral/statistic',

  //* Marketplace
  Marketplace: '/marketplace',
  MarketplaceList: '/marketplace/products',
  MarketplaceMyProducts: '/marketplace/my-products',

  //* Public
  OptoutConfirm: '/public/optout/confirm',

  //* Warning
  WarningUpdateBillingInfo: '/warning/billing-info',
  WarningMinBalance: '/warning/min-balance',
};
